import { SwipeableDrawer } from '@mui/material';
import { Calendar, CreditCard, PencilLine, SignOut } from '@phosphor-icons/react';
import moment from 'jalali-moment';
import Cookies from 'js-cookie';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { logout } from '../../services/apis/global';
import { urls } from '../../services/endPoint.ts';
import { api } from '../../services/http.ts';
import { SET_LOADING } from '../../services/redux/reducers/loadingSlice.ts';
import { useAppSelector } from '../../services/redux/store';
import { Addresses } from './Addresses';
import { ProfileCard } from './profileCard';
import WorkerOffModal from './WorkerOffModal.tsx';

export default function Profile() {
  const loggedIn = Cookies.get('worker-token') != undefined;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [workerOffModal, setWorkerOffModal] = useState(false)
  const handleLogout = () => {
    sessionStorage.removeItem('new-order');
    sessionStorage.removeItem('step');
    logout(dispatch);
    navigate('/login');
    window.location.reload();
  };

  useEffect(() => {
    if (!loggedIn) {
      navigate('/login');
    }
  }, []);

  return (
    <main className="profileMain">
      <ProfileCard/>
      <section className="infoBox">
        <div className="profileButton" onClick={() => navigate('/profile/edit')}>
          <PencilLine size={20}/>
          <span>مشاهده اطلاعات کاربری</span>
        </div>
        <div className="profileButton" onClick={() => navigate('/profile/bank')}>
          <CreditCard size={20}/>
          <span>مشاهده اطلاعات بانکی</span>
        </div>
        <div className="profileButton" onClick={() => setWorkerOffModal(true)}>
          <Calendar size={20}/>
          <span>غیر فعال کردن پنل</span>
        </div>
        <div className="profileButton" onClick={handleLogout}>
          <SignOut
            weight={'bold'}
            className="logout"
            size={20}
            color={'#e85959'}
          />
          <span>خروج از حساب</span>
        </div>
      </section>
      <h3>

      </h3>
      {/* <h3>آدرس ها</h3> */}
      {/* <Addresses editable={true} mini={true}/> */}
      {workerOffModal && <WorkerOffModal workerOffModal={workerOffModal} setWorkerOffModal={setWorkerOffModal}/>}
    </main>
  );
}
